import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/pages/Home'
import Login from '@/components/auth/Login'
import Section from '@/components/pages/Section'
import SubSection from '@/components/pages/SubSection'
import Contact from '@/components/pages/Contact'
import Downloads from '@/components/pages/Downloads'
import Signup from '@/components/pages/Signup'
import Reset from '@/components/auth/Reset'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        auth: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        auth: false
      }
    },
    {
      name: 'resetPassword',
      path: '/user/recover/:id/:code',
      component: Reset,
      meta: {
        auth: false
      }
    },
    {
      path: '/request',
      name: 'Signup',
      component: Signup,
      meta: {
        auth: false
      }
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
      meta: {
        auth: true
      }
    },
    {
      path: '/download',
      name: 'Download',
      component: Downloads,
      meta: {
        auth: true,
        title: 'Download Center'
      }
    },
    {
      name: 'Section',
      path: '/:slug',
      component: Section,
      meta: {
        auth: true
      }
    },
    {
      name: 'SubSection',
      path: '/:slug/:slug2',
      component: SubSection,
      meta: {
        auth: true
      }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({selector: to.hash})
        }, 500)
      })
      // setTimeout(() => {
      //   return {selector: to.hash}
      // }, 2000)
    } else {
      return {x: 0, y: 0}
    }
  }
})



// WEBPACK FOOTER //
// ./src/router.js